/**
 * Diccionario base es-PE (locale por defecto). Claves planas con notación por
 * puntos. Para agregar un locale: crear otro archivo con la MISMA forma y
 * registrarlo en ../index.ts. Interpolación con {var}.
 *
 * Los textos legales de consentimiento están VERSIONADOS: al cambiar el texto
 * hay que subir la versión (sufijo .version) porque el backend persiste la
 * versión otorgada por el padre (trazabilidad de consentimiento).
 */
export const esPE = {
  "app.name": "VoiceCheck",
  "app.tagline": "Screening fonético para tu peque",

  "tab.aria": "Navegación principal",
  "tab.home": "Inicio",
  "tab.evaluations": "Evaluaciones",
  "tab.patients": "Pacientes",
  "tab.credits": "Créditos",
  "tab.profile": "Perfil",
  "nav.back": "Atrás",

  "common.continue": "Continuar",
  "common.back": "Volver",
  "common.cancel": "Cancelar",
  "common.save": "Guardar",
  "common.saving": "Guardando…",
  "common.loading": "Cargando…",
  "common.retry": "Reintentar",
  "common.error": "Ocurrió un error",
  "common.close": "Cerrar",
  "common.years": "{n} años",
  "common.logout": "Cerrar sesión",

  "role.padre": "Padre / Madre",
  "role.terapeuta": "Terapeuta",
  "role.admin": "Administrador",

  "auth.login.title": "Inicia sesión",
  "auth.login.email": "Correo electrónico",
  "auth.login.password": "Contraseña",
  "auth.login.submit": "Entrar",
  "auth.login.toRegister": "¿No tienes cuenta? Regístrate",
  "auth.register.title": "Crea tu cuenta",
  "auth.register.name": "Nombre",
  "auth.register.roleQuestion": "¿Cómo usarás VoiceCheck?",
  "auth.register.submit": "Crear cuenta",
  "auth.register.toLogin": "¿Ya tienes cuenta? Inicia sesión",
  "auth.error.credenciales": "Correo o contraseña incorrectos",

  "parent.dashboard.title": "Mis peques",
  "parent.dashboard.addChild": "Registrar un peque",
  "parent.dashboard.empty": "Aún no registras a ningún peque. Empecemos 👶",
  "parent.dashboard.startEval": "Iniciar evaluación",
  "parent.dashboard.viewPlans": "Plan de práctica",

  "child.new.title": "Registrar peque",
  "child.new.name": "Nombre del peque",
  "child.new.birthdate": "Fecha de nacimiento",
  "child.new.submit": "Registrar",

  "consent.title": "Permisos de {name}",
  "consent.intro": "Para evaluar a {name} necesitamos tu consentimiento. Son dos permisos SEPARADOS: puedes otorgar solo uno.",
  "consent.audio.label": "Grabación de audio",
  "consent.audio.text": "Autorizo la grabación de la voz de mi hijo/a durante las evaluaciones. Los audios se cifran y solo los verá el fonoaudiólogo vinculado. Puedo revocar este permiso cuando quiera.",
  "consent.audio.version": "audio-v1.0",
  "consent.fotos.label": "Fotos orofaciales",
  "consent.fotos.text": "Autorizo la captura de fotografías del área de la boca (labios, lengua) sin incluir los ojos, con fines clínicos. Se almacenan cifradas y con acceso exclusivo del terapeuta vinculado. Puedo revocar este permiso cuando quiera.",
  "consent.fotos.version": "fotos_orofaciales-v1.0",
  "consent.granted": "Otorgado ✓",
  "consent.grant": "Otorgar permiso",
  "consent.required.audio": "Necesitas otorgar el permiso de audio para evaluar.",

  "fotos.title": "Fotos orofaciales de {name}",
  "fotos.intro": "Toma 6 fotos guiadas del área de la boca. Encuadra SIN los ojos. Puedes rehacer cualquiera.",
  "fotos.capture": "Tomar foto",
  "fotos.retake": "Rehacer",
  "fotos.uploading": "Subiendo…",
  "fotos.done": "Fotos completas",
  "fotos.skip": "Omitir por ahora",
  "fotos.toma.labios_reposo": "Labios en reposo",
  "fotos.toma.sonrisa": "Sonrisa amplia",
  "fotos.toma.boca_abierta": "Boca abierta",
  "fotos.toma.lengua_protruida": "Lengua afuera",
  "fotos.toma.lengua_elevada": "Lengua arriba",
  "fotos.toma.perfil": "Perfil del rostro",
  "fotos.hint.labios_reposo": "Boca cerrada y relajada, de frente.",
  "fotos.hint.sonrisa": "Sonríe mostrando los dientes.",
  "fotos.hint.boca_abierta": "Abre bien la boca.",
  "fotos.hint.lengua_protruida": "Saca la lengua hacia afuera.",
  "fotos.hint.lengua_elevada": "Sube la lengua hacia el paladar.",
  "fotos.hint.perfil": "Gira la cara de lado (perfil).",

  "eval.prep.title": "Antes de empezar",
  "eval.prep.start": "Todo listo, ¡empecemos!",
  "eval.prep.mic": "Permite el acceso al micrófono cuando la app lo pida.",
  "eval.prep.qaMode": "Modo prueba (QA): batería mínima, sin validez clínica",
  "eval.rec.tapRepeat": "Toca y repite",
  "eval.rec.tapName": "Toca y di el nombre",
  "eval.rec.recording": "Grabando… habla fuerte",
  "eval.rec.saved": "¡Muy bien! 🎉",
  "eval.listen": "🔊 Escuchar otra vez",
  "eval.processing": "Analizando las grabaciones…",
  "eval.processing.hint": "La IA está procesando la voz. En un momento verás el resumen.",
  "eval.done.title": "¡BRAVO! Lo hiciste muy bien",
  "eval.done.toReport": "Ver resumen",

  // ---- batería PEFF (fase 4) ------------------------------------------------
  // Las consignas son LITERALES del master §2.1/§3.1: no se reescriben sin
  // pasar por el equipo clínico. Las variantes `.bigkid` son el ageTone de la
  // banda D (7–10 años): mismo contenido, tono menos infantil.
  "eval.peff.mic.title": "Probemos el micrófono",
  "eval.peff.mic.body": "Di “hola” con voz fuerte para ver si te escuchamos.",
  "eval.peff.mic.test": "Probar micrófono",
  "eval.peff.mic.testing": "Escuchando…",
  "eval.peff.mic.ok": "¡Te escuchamos! 🎉",
  "eval.peff.mic.fail": "No te escuchamos. Revisa el micrófono y prueba otra vez.",
  "eval.peff.mic.start": "Empezar",

  "eval.peff.consigna.F1":
    "¡Hola! Escucha atentamente el sonido y repite después de mí. ¿Estás listo?",
  "eval.peff.consigna.F2":
    "Voy a mostrarte unas imágenes y tú me dirás el nombre de cada una. ¿Estás listo?",
  "eval.peff.consigna.F3": "Ahora yo digo el nombre y tú lo repites después de mí.",
  "eval.peff.consigna.F4": "Voy a decirte unas oraciones y tú repetirás después de mí. ¿Estás listo?",
  "eval.peff.consigna.PSF1": "Voy a mostrarte unas imágenes y tú me dirás el nombre de cada una.",
  "eval.peff.consigna.PSF2": "Ahora yo digo la palabra. Escucha… y luego la dices tú.",
  "eval.peff.consigna.F1.bigkid":
    "Escucha con atención cada sonido y repítelo después de mí. ¿Comenzamos?",
  "eval.peff.consigna.F2.bigkid": "Te mostraré unas imágenes y me dirás el nombre de cada una.",
  "eval.peff.consigna.F3.bigkid": "Ahora yo digo el nombre y tú lo repites después de mí.",
  "eval.peff.consigna.F4.bigkid": "Te diré unas oraciones y las repetirás después de mí.",
  "eval.peff.consigna.PSF1.bigkid": "Te mostraré unas imágenes y me dirás el nombre de cada una.",
  "eval.peff.consigna.PSF2.bigkid": "Escucha la palabra, responde una pregunta y luego dila tú.",
  "eval.peff.consigna.start": "¡Sí, vamos! 🚀",
  "eval.peff.consigna.start.bigkid": "Comenzar",

  "eval.peff.ej.F1": "Sílabas",
  "eval.peff.ej.F2": "Nombrar",
  "eval.peff.ej.F3": "Repetir",
  "eval.peff.ej.F4": "Oraciones",
  "eval.peff.ej.PSF1": "Nombrar",
  "eval.peff.ej.PSF2": "Repetir después",

  "eval.peff.item.queEs": "¿Qué es?",
  "eval.peff.item.escucha": "Escucha…",
  "eval.peff.item.ahoraTu": "Ahora dila tú",
  "eval.peff.item.repite": "Repite",
  "eval.peff.item.noEvoca": "No pasa nada, seguimos 💛",
  "eval.peff.item.noEvoca.bigkid": "Sin problema, continuamos.",
  "eval.peff.item.pistaPlaceholder": "Piensa un poquito… ¿qué será?",
  "eval.peff.item.distractoraPlaceholder": "¿De qué color es?",
  "eval.peff.item.distractoraOk": "Ya respondí",

  "eval.peff.pausa.title": "Pausa 🌿",
  "eval.peff.pausa.body": "Estiren las piernas y tomen agua. Cuando quieran, seguimos.",
  "eval.peff.pausa.continue": "Seguir",

  "eval.peff.suspend.button": "Pausar y guardar",
  "eval.peff.suspend.title": "Guardamos lo avanzado",
  "eval.peff.suspend.body":
    "La evaluación quedó guardada. Podrán retomarla desde este mismo ejercicio otro día.",
  "eval.peff.suspend.resume": "Retomar ahora",
  "eval.peff.suspend.exit": "Salir",

  "eval.peff.sesion.title": "¡Terminamos por hoy!",
  "eval.peff.sesion.body":
    "Esta fue la primera parte. Guardamos tu avance: para la segunda parte, vuelve al historial del niño y toca «Reanudar». 💫",
  "eval.peff.sesion.exit": "Listo",

  "eval.peff.close.processing": "Preparando el pre-informe…",
  "eval.peff.close.processingHint": "Estamos analizando las grabaciones. Toma un momento.",
  "eval.peff.close.ready": "El pre-informe está listo",
  "eval.peff.close.readyHint":
    "Un profesional debe validarlo: es un pre-informe, nunca un diagnóstico.",
  "eval.peff.close.toReport": "Ver pre-informe",

  "eval.peff.adult.peek": "Solo evaluador",
  "eval.peff.adult.noAttempt": "No lo intentó",
  "eval.peff.adult.doubt": "Marcar dudoso",
  "eval.peff.adult.next": "Siguiente",
  "eval.peff.stars": "⭐ {n}",

  "report.title": "Resumen de la sesión",
  "report.words": "Palabras",
  "report.correct": "Correctas",
  "report.review": "En revisión",
  "report.processes": "Patrones detectados",
  "report.summary": "Resumen",
  "report.recommendations": "Recomendaciones",
  "report.play": "▶ Escuchar",
  "report.ctaPlan": "Crear plan de práctica",
  "report.findTherapist": "Buscar un terapeuta",

  "practice.title": "Práctica",
  "practice.start": "Empezar práctica",
  "practice.model": "Mira y escucha el modelo",
  "practice.attempt": "Grabar intento",
  "practice.attemptsLeft": "Intentos: {n} de {max}",
  "practice.finish": "Terminar práctica",
  "practice.progress": "Progreso",

  "therapist.dashboard.title": "Panel del terapeuta",
  "therapist.dashboard.children": "Niños vinculados",
  "therapist.dashboard.noCredits": "Necesitas créditos para crear evaluaciones. Compra un paquete.",
  "therapist.link.title": "Vincular un niño",
  "therapist.link.claimCode": "Reclamar código del padre",
  "therapist.link.codePlaceholder": "Código de 6 dígitos",
  "therapist.link.invite": "Invitar a un padre",
  "therapist.link.parentEmail": "Correo del padre",
  "therapist.tests.title": "Mis pruebas personalizadas",
  "therapist.tests.new": "Nueva prueba",
  "therapist.credits.title": "Créditos",
  "therapist.credits.buy": "Comprar",
  "therapist.profile.title": "Perfil de marketplace",
  "therapist.profile.publish": "Publicar perfil",
  "therapist.profile.unpublish": "Despublicar",
  "therapist.profile.credential": "Verificar credencial (colegiatura)",
  "therapist.profile.needVerif": "Debes verificar tu colegiatura antes de publicar.",

  "marketplace.title": "Encuentra un terapeuta",
  "marketplace.verified": "Verificado ✓",
  "marketplace.contact": "Contactar",

  "nav.home": "Inicio",
  "nav.marketplace": "Terapeutas",

  // ---- historial de baterías (padre) ----------------------------------------
  "history.title": "Historial de evaluaciones",
  "history.empty": "Aún no hay evaluaciones para este peque.",
  "history.link": "Historial",
  "history.banda": "Banda {banda}",
  "history.estado.enProgreso": "En progreso — {hechos} de {total} ejercicios",
  "history.estado.procesando": "Procesando…",
  "history.estado.preinformeListo": "Pre-informe listo",
  "history.estado.completada": "Completada, procesando pre-informe",
  "history.estado.pausada": "Pausada",
  "history.estado.cancelada": "Cancelada",
  "history.resume": "Reanudar",
  "history.viewPre": "Ver pre-informe",
  "history.createdAt": "Iniciada el {fecha}",
  "history.qaBadge": "PRUEBA (QA)",

  // ---- modo prueba (QA): banner imborrable, sin validez clínica --------------
  "qa.banner": "EVALUACIÓN DE PRUEBA — SIN VALIDEZ CLÍNICA",
  "qa.badge": "PRUEBA",

  // ---- pre-informe / informe validado (padre) -------------------------------
  "report.pre.title": "Pre-informe de screening",
  "report.validado.title": "Informe validado",
  "report.validado.badge": "Validado por {nombre} · Colegiatura {colegiatura}",
  "report.validado.firmadoEn": "Firmado el {fecha}",
  "report.conclusion": "Conclusión profesional",
  "report.observaciones": "Observaciones",
  "report.verPrevio": "Ver pre-informe automático (versión anterior)",
  "report.ocultarPrevio": "Ocultar pre-informe automático",
  "report.previo.title": "Pre-informe automático (versión anterior)",
  "report.share": "Compartir con un terapeuta",
  "report.pre.prep.title": "Pre-informe en preparación",
  "report.pre.prep.body": "El informe de la batería PEFF aún se está generando. Las grabaciones ya quedaron guardadas.",

  // ---- compartir con terapeuta (marketplace) --------------------------------
  "share.cta": "Compartir pre-informe",
  "share.sharing": "Enviando…",
  "share.sent": "Invitación enviada — el terapeuta la verá en su panel.",
  "share.banner": "Elige un terapeuta para compartir el pre-informe. Él lo revisará y podrá validarlo.",

  // ---- mesa de revisión clínica (terapeuta) ---------------------------------
  "workbench.title": "Mesa de revisión",
  "workbench.open": "Mesa de revisión",
  "workbench.child": "Niño {id}",
  "workbench.profile": "Perfil (pre-informe): {profile}",
  "workbench.trace": "Trazabilidad — engine {engine} · scoring {scoring}",
  "workbench.tableTitle": "Ítems de la batería",
  "workbench.focusTitle": "Revisión ítem a ítem",
  "workbench.col.ejercicio": "Ejercicio",
  "workbench.col.estimulo": "Estímulo",
  "workbench.col.objetivo": "Fonemas objetivo",
  "workbench.col.producido": "Producido",
  "workbench.col.codigos": "Códigos motor",
  "workbench.col.estados": "Estados",
  "workbench.col.flags": "Marcas",
  "workbench.col.audio": "Audio",
  "workbench.col.accion": "Acción",
  "workbench.correct": "Corregir",
  "workbench.correct.codigoOriginal": "Código original",
  "workbench.correct.codigoCorregido": "Código corregido",
  "workbench.correct.transcripcion": "Transcripción corregida",
  "workbench.correct.comentario": "Comentario",
  "workbench.correct.save": "Guardar corrección",
  "workbench.correct.none": "(sin código)",
  "workbench.correct.saved": "Corrección guardada ✓",
  "workbench.flag.withHint": "pista",
  "workbench.flag.noEvoca": "no evoca",
  "workbench.flag.revisarAudio": "revisar audio",
  "workbench.flag.dudoso": "dudoso",
  "workbench.flag.pendiente": "pend. validación",
  "workbench.item": "Ítem {n} de {total}",
  "workbench.prev": "← Anterior",
  "workbench.next": "Siguiente →",
  "workbench.noItems": "Esta batería no tiene ítems para revisar.",
  "workbench.onlyFlags": "Solo ítems con marcas ({n})",
  "workbench.continuous": "Reproducción continua",
  "workbench.noFlagged": "No hay ítems con marcas en esta batería.",
  "workbench.noAudio": "Este ítem no tiene audio (no evocó / sin intento / no grabado).",
  "workbench.kbdHint": "Teclas: Espacio reproduce/pausa · → siguiente · ← anterior.",
  "workbench.audio.expiredDirty":
    "El enlace de audio expiró. Tu corrección en curso está intacta; guárdala o descártala, o refresca ahora.",
  "workbench.audio.refreshing": "El enlace de audio expiró — refrescando…",
  "workbench.audio.refreshNow": "Refrescar audio",
  "workbench.audio.noReproducible":
    "Audio no reproducible (grabación dañada o vacía). El ítem ya está marcado para revisión.",
  "workbench.audio.noReproducibleShort": "audio dañado",
  "workbench.report.informe": "Informe (vista terapeuta)",
  "workbench.report.raw": "PeffReport (M1) — datos crudos",
  "workbench.report.unavailable": "No disponible.",
  "workbench.validacion.title": "Validación del informe",
  "workbench.validacion.observaciones": "Observaciones generales",
  "workbench.validacion.conclusion": "Conclusión profesional",
  "workbench.validacion.draft": "Guardar borrador",
  "workbench.validacion.sign": "FIRMAR informe",
  "workbench.validacion.signed": "Firmado el {fecha} · {nombre} · {colegiatura}",
  "workbench.validacion.signedHint": "El informe está firmado y el padre ya ve la versión validada.",
  "workbench.validacion.draftSaved": "Borrador guardado ✓",
  "workbench.validacion.needProfile": "Necesitas un perfil verificado para firmar.",
  "workbench.validacion.toProfile": "Ir a mi perfil",

  // ---- invitaciones + baterías (dashboard terapeuta) ------------------------
  "therapist.invites.title": "Invitaciones para revisar",
  "therapist.invites.item": "Batería {bateria} · Niño {nino}",
  "therapist.invites.accept": "Aceptar",
  "therapist.invites.reject": "Rechazar",
  "therapist.invites.empty": "No tienes invitaciones pendientes.",
  "therapist.baterias.toggle": "Baterías",
  "therapist.baterias.empty": "Sin baterías procesadas todavía.",
  "therapist.baterias.review": "Revisar",
} as const;

export type MessageKey = keyof typeof esPE;
export type Dictionary = Record<MessageKey, string>;
